module.exports = __webpack_public_path__ + "static/img/QB20.f6c93de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QB20.png
// module id = y94E
// module chunks = 2